





















































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {IpSettings} from '@/model/network/settings/IpSettings';
import {IpMode} from '@/model/network/IpMode';
import {IpAddressingMethod} from '@/model/network/IpAddressingMethod';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component
export default class NetworkIpSettingsDisplay extends Mixins<BaseComponent>(BaseComponent) {
  @Prop()
  private ipSettings!: IpSettings;

  @Prop(String)
  private mode!: IpMode;

  private IpAddressingMethod = IpAddressingMethod;
}
